import { createDeferredAppInsights } from '~/utils/deferredAppInsights'
import { useTypedRuntimeConfig } from '~/utils/runtimeConfig'

// Replaces nuxt-applicationinsights' client plugin (clientEnabled: false in
// nuxt.config.ts), which imported the SDK statically and started it before the app
// mounted. The SDK now loads after hydration; until then $appInsights queues (see
// utils/deferredAppInsights.ts). Without a connection string (local dev) it never
// loads, and $appInsights is a no-op. 'pre', so the plugins that read $appInsights
// at setup get it. Page views are named after their route where they are tracked
// (page-view-tracking.client.ts), which the module did in an initializer.
//
// The module's $fetch re-creation is not needed: Nuxt's client $fetch is made from
// ofetch's default instance, which looks up globalThis.fetch on every call, so it and
// its $fetch.create copies reach the SDK's fetch wrapper.
export default defineNuxtPlugin({
  name: 'app-insights',
  enforce: 'pre',
  setup () {
    const appInsights = createDeferredAppInsights(useTypedRuntimeConfig().public.applicationinsights)
    onNuxtReady(() => appInsights.load(() => import('@microsoft/applicationinsights-web')))
    return { provide: { appInsights: appInsights.client } }
  }
})
